import React, { useContext, useEffect, useState } from 'react';
import { Navigate, useLocation  } from 'react-router-dom'; // ✅ React Router v6 style
 
import userSessionLogs from './apis/userSessionLogs';
import { UserTypeContext } from './AppRoute';
import customLogoutResponse from './apis/logout/customLogout';
 
const ProtectedRoute = ({ element }) => {
  const { userRecruitmentpartnerId, userIdType } = useContext(UserTypeContext);
  const [isUserActive, setIsUserActive] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const userId = localStorage.getItem('userID') || userIdType;
  const token = localStorage.getItem('token');
  const location = useLocation();
 
  const sendActivityPing = async () => {
    try {
      const res = await userSessionLogs(userId, token);
      if (res.status === 401 && res.data.message === 'Token expired') {
        await customLogoutResponse({
          userId,
          recruitementPartnerId: userRecruitmentpartnerId,
        });
        localStorage.clear();
        setRedirect(true);
      }
    } catch (error) {
      console.error('Error in sendActivityPing:', error);
      if (error.response?.status === 401 && error.response?.data?.message === 'Token expired') {
        await customLogoutResponse({
          userId,
          recruitementPartnerId: userRecruitmentpartnerId,
        });
        localStorage.clear();
        setRedirect(true);
      }
    }
  };
 
  useEffect(() => {

    if (!token) return;
    const handleUserActivity = () => setIsUserActive(true);
 
    const events = ['click', 'mousemove', 'keydown', 'mousedown', 'touchstart'];
    events.forEach(event => window.addEventListener(event, handleUserActivity));
 
    const intervalId = setInterval(() => {
      if (isUserActive) {
        sendActivityPing();
        setIsUserActive(false);
      }
    }, 60000); // Every 1 minute
 
    return () => {
      events.forEach(event => window.removeEventListener(event, handleUserActivity));
      clearInterval(intervalId);
    };
  }, [isUserActive]);
 
  useEffect(() => {
    if (!token) return;
    const events = ['click', 'mousemove', 'keydown', 'mousedown', 'touchstart'];
    let inactivityTimer;
 
    const resetTimer = () => {
      clearTimeout(inactivityTimer);
      inactivityTimer = setTimeout(async () => {
        try {
          await customLogoutResponse({
            userId,
            recruitementPartnerId: userRecruitmentpartnerId,
          });
        } catch (error) {
          console.error('Error during customLogoutResponse:', error);
        }
        localStorage.clear();
        setRedirect(true);
      }, 15 * 60 * 1000); // 15 minutes
    };
 
    events.forEach(event => window.addEventListener(event, resetTimer));
    resetTimer();
 
    return () => {
      events.forEach(event => window.removeEventListener(event, resetTimer));
      clearTimeout(inactivityTimer);
    };
  }, []);
 
  if (redirect || !token) {
    return <Navigate to="/signIn" replace state={{ from: location }} />;
  }
 
  return element;
};
 
export default ProtectedRoute;
